import { useTranslation } from "react-i18next";

const getOfficeDetails = (t: (key: string) => string) => [
  {
    icon: "ri-map-pin-2-fill",
    label: t("infoOffice"),
    lines: [t("infoLine1"), t("infoLine2")],
  },
  {
    icon: "ri-phone-fill",
    label: t("infoPhone"),
    lines: ["RW :+250 788 377 109 ", "RW :+250 788 377 109 "],
    href: "tel:+250700000000",
  },
  {
    icon: "ri-mail-fill",
    label: t("infoEmail"),
    lines: [t("infoEmail1"), t("infoEmail2")],
    href: "mailto:info@africainvestmentportal.com",
  },
  {
    icon: "ri-time-fill",
    label: t("infoHours"),
    lines: [t("infoHoursWeekday"), t("infoHoursSaturday")],
  },
];

const getSocialLinks = (t: (key: string) => string) => [
  { icon: "ri-linkedin-fill", href: "https://linkedin.com", label: t("navLinkedIn") },
  { icon: "ri-twitter-x-fill", href: "https://twitter.com", label: t("navTwitter") },
  { icon: "ri-whatsapp-fill", href: "https://wa.me/250700000000", label: "WhatsApp" },
];

export default function ContactInfo() {
  const { t } = useTranslation();
  const officeDetails = getOfficeDetails(t);
  const socialLinks = getSocialLinks(t);

  return (
    <div className="flex flex-col gap-8">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {officeDetails.map((item) => (
          <div
            key={item.label}
            className="bg-white rounded-lg p-5 border border-gray-100 flex flex-col gap-3"
          >
            <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-[#0A1628]/10">
              <i className={`${item.icon} text-[#00C2C2] text-base`} />
            </div>
            <div>
              <p className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-1.5">{item.label}</p>
              {item.lines.map((line, i) =>
                item.href && i === 0 ? (
                  <a
                    key={line}
                    href={item.href}
                    className="block text-sm text-gray-700 font-medium hover:text-[#00C2C2] transition-colors"
                  >
                    {line}
                  </a>
                ) : (
                  <p key={line} className="text-sm text-gray-500">{line}</p>
                )
              )}
            </div>
          </div>
        ))}
      </div>

      <div>
        <p className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-3">{t("infoFollowUs")}</p>
        <div className="flex items-center gap-3">
          {socialLinks.map((s) => (
            <a
              key={s.label}
              href={s.href}
              rel="nofollow noopener noreferrer"
              target="_blank"
              aria-label={s.label}
              className="w-10 h-10 flex items-center justify-center rounded-lg border border-gray-200 text-gray-500 hover:text-[#00C2C2] hover:border-[#00C2C2]/40 hover:bg-[#00C2C2]/5 transition-all cursor-pointer"
            >
              <i className={`${s.icon} text-base`} />
            </a>
          ))}
        </div>
      </div>

      <div className="rounded-lg overflow-hidden border border-gray-100 h-[280px] lg:h-[320px] w-full">
        <iframe
          title="AIP Office — Kigali, Rwanda"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d63799.41051388!2d30.0445197!3d-1.9440727!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x19dca4258ed8e797%3A0xf32b36a5411d0bc8!2sKigali%2C%20Rwanda!5e0!3m2!1sen!2s!4v1713823200000!5m2!1sen!2s"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          aria-label="Google Map showing AIP office location in Kigali, Rwanda"
        />
      </div>
    </div>
  );
}